module.exports = {
  ShanghaiPort: 'Cảng Thượng Hải',
  QingdaoPort: 'Cảng Thanh Đảo',
  DeletionGuide: 'Hướng dẫn chỉnh sửa/xóa',
  BusinessData: 'Tài liệu nghiệp vụ',
  DropOffGoods: 'Hàng rớt (không lên tàu)',
  CounterDeletion: 'Yêu cầu xóa đơn tại quầy',
  CertificateOfNonBoarding: 'Giấy chứng nhận hàng chưa lên tàu',
  CarrierName: 'Tên đại lý tàu biển',
  Text1: 'Phạm vi dịch vụ (nền tảng hỗ trợ',
  Text2: 'hãng tàu và',
  Text3: 'đại lý tàu gửi manifest, danh sách như sau:)',
  Text4: 'Hướng dẫn xử lý "Thay đổi hoặc xóa manifest dự kiến"',
  Title1: 'Phạm vi dịch vụ - Hỗ trợ nền tảng',
  Title2: 'Gửi VGM của hãng tàu, danh sách như sau:',
  Remark1: 'Shanghai Zhenhua (đại lý tàu)',
  Remark2: 'Cấm Dongjin DJS, Antong ONTO, Datong EAS, Fan Zhou PCS',
  Remark3: 'Shanghai Minsheng (đại lý tàu)',
  Remark4: 'Cấm tuyến Đài Loan/Nhật Bản của Minsheng. Tuyến Đài Loan của Wan Hai WHL được phép gửi',
  Remark5: 'Jincheng (đại lý tàu)',
  Remark6: 'Cấm Jinjiang JJ',
  Remark7: 'Chính Lợi (hãng tàu)',
  Remark8: 'Tuyến Đài Loan "CNC - Chính Lợi", vui lòng chọn mã hãng tàu "CST - Bảo Hoa"',
  Remark9: 'Tân Đông (hãng tàu)',
  Remark10: 'Tuyến Incheon Hàn Quốc "NOS - Tân Đông", vui lòng chọn mã hãng tàu "NSI - Ningbo Ocean"',
  Remark11: 'Singapore Shipping (hãng tàu)',
  Remark12: 'Nhánh của Bian Shipping, vận đơn bắt đầu bằng SEC được phép gửi, chọn hãng tàu "SCO - Singapore Shipping"',
  Remark13: 'Hải Lĩnh Singapore (hãng tàu)',
  Remark14: 'FCSL - Volta UAE là đại lý Volta Thượng Hải, chọn hãng tàu "SLS - Hải Lĩnh Singapore"',
  Remark15: 'Shanghai CUL (đại lý tàu)',
  Remark16: 'Cấm CUL, cảng Nhật Chiếu RPS',
  Remark17: 'Trước khi tàu chạy, chưa quá hạn manifest quy định bởi đại lý và chưa khai báo hải quan toàn bộ:',
  Remark18: 'a) Nếu cần thay đổi hãng tàu, đại lý, số vận đơn, tên tàu, chuyến, số container, số seal, tên hàng, loại container: Chọn manifest gốc trong "Đã gửi", gửi yêu cầu xóa manifest, sau khi xóa hoàn tất thì gửi lại manifest mới. Riêng loại container chỉ cần xóa nếu sai với 4 đại lý CUL/OOCL/Sinotrans/Zhenhua, các trường hợp khác có thể sửa trực tiếp.',
  Remark19: 'b) Nếu cần thay đổi thông tin khác ngoài 9 mục trên: Chọn manifest trong "Đã gửi", gửi yêu cầu sửa đổi và chờ phản hồi.',
  Remark20: 'c) Đối với lô hàng ghép (consolidation):',
  Remark21: 'i) Nếu cần sửa thông tin 1 hoặc vài lô, tham khảo mục b trên.',
  Remark22: 'ii) Nếu cần xóa 1 hoặc vài lô: Xóa toàn bộ manifest cùng số container rồi gửi lại manifest mới.',
  Remark23: 'iii) Nếu cần thêm 1 lô ghép: Có thể gửi trực tiếp (với đại lý Hanghua/Penghua, số lô ghép phải nhập chung với lô chính).',
  Remark24: 'Trước khi tàu chạy nhưng đã quá hạn manifest hoặc khách đã khai báo hải quan:',
  Remark25: 'a) Nếu khách đã khai báo: Phải hủy xác nhận hải quan trước.',
  Remark26: 'b) Liên hệ đại lý tàu tương ứng để hướng dẫn thao tác (hoặc hỏi CSKH chúng tôi).',
  Remark27: 'c) Nếu đã thông quan: Nộp hồ sơ giấy đến quầy đại lý để hủy trạng thái "đã thông quan" (chi tiết hỏi CSKH).',
  Remark28: 'Sau khi tàu chạy, yêu cầu xóa đơn:',
  Remark29: 'a) Nếu khách đã khai báo: Phải hủy tờ khai hải quan trước.',
  Remark30: 'b) Nộp hồ sơ giấy đến quầy đại lý (tối thiểu 4 loại): "Đơn xin xóa", "Tờ khai hải quan", "Giải trình xóa đơn", "Ảnh chụp tra cứu trạng thái thông quan" (có dịch vụ đại lý, liên hệ CSKH).',
  Remark31: 'Phụ lục: Địa chỉ quầy dịch vụ các đại lý tàu',
  CompanyName1: 'Penavico Thượng Hải',
  CompanyName2: 'Sinotrans Thượng Hải',
  CompanyName3: 'Liên Hiệp Thượng Hải',
  CompanyName4: 'Hoa Cảng Thượng Hải',
  CompanyName5: 'Thuận Đức Thượng Hải',
  CompanyName6: 'Hàng Hải Thượng Hải',
  CompanyName7: 'Dân Sinh Thượng Hải',
  CompanyName8: 'Bằng Hoa Thượng Hải',
  CompanyName9: 'Bằng Hải Thượng Hải',
  CompanyName10: 'Trung Liên Thượng Hải (Trung Hòa)',
  CompanyName11: 'Chấn Hoa Thượng Hải',
  CompanyName12: 'Tân Hải',
  CompanyName13: 'Cẩm Thành',
  CompanyName14: 'Đông Phương Hải Ngoại',
  CompanyName15: 'Liên Hiệp Cảng Thượng Hải',
  CompanyName16: 'Trung Liên Thượng Hải',
  CompanyName17: 'Bằng Hoa',
  CompanyAddress1: 'Lầu 5, số 531 đường Ngô Tùng, khu Hồng Khẩu',
  CompanyAddress2: 'Đại sảnh lầu 3, số 188 đường Phúc Kiến Trung',
  CompanyAddress3: 'Tầng 1, số 916 đường Đông Đại Danh, khu Hồng Khẩu',
  CompanyAddress4: 'Phòng 1601, số 501 đường Đông Đại Danh',
  CompanyAddress5: 'Phòng 2701, số 440 đường Hải Luân',
  CompanyAddress6: 'Lầu 2, số 99 đường Hoàng Phố, khu Hồng Khẩu',
  CompanyAddress7: 'Lầu 16, Quảng trường Tài sản Quốc tế Tuấn Phong, số 1619 đường Đại Liên',
  CompanyAddress8: 'Phòng 501, 502, 508, lầu 5, tòa nhà 1, Trung Thiên Đại Hạ, số 1063 đường Tứ Bình, khu Dương Phố',
  CompanyAddress9: 'Phòng 1807-1809, số 700 đường Diên An Đông',
  CompanyAddress10: 'Lầu 24, số 908 đường Đông Đại Danh, khu Hồng Khẩu',
  CompanyAddress11: 'Lầu 21, Quảng trường Cảng Thái, số 700 đường Diên An Đông',
  CompanyAddress12: 'Lầu 8, Tòa nhà Tài chính Gia Hóa Thượng Hải, số 133 đường Thiên Đồng, khu Hồng Khẩu',
  CompanyAddress13: 'Lầu 8, số 1200 đường Diên An Đông',
  CompanyAddress14: 'Lầu 20, số 841 đường Diên An Trung'
}
